const localizationFile = require('./assets/localization/resource_en.json');
export const OrganizationTypes = {
	authority: 'authority',
	industry: 'industry',
	facility: 'facility'
};

export const RegulatoryProgramName = {
	ipp: 'iPP',
	fog: 'fOG',
	ccc: 'cCC'
};

export const IppAASAuthorityInformationDataApiMapping = {
	name: 'authorityName',
	organizationRegulatoryProgramId: 'organizationRegulatoryProgramId',
	organizationId: 'organizationId',
	addressLine1: 'address1',
	addressLine2: 'address2',
	cityName: 'city',
	jurisdictionName: 'state',
	jurisdictionId: 'jurisdictionId',
	jurisdictionCode: 'jurisdictionCode',
	referenceNumber: 'referenceNumber',
	zipCode: 'zipCode',
	phoneNumber: 'phoneNumber',
	phoneExt: 'phoneNumberExt',
	faxNumber: 'faxNumber',
	webSiteUrl: 'websiteURL',
	npdes: 'npdes',
	signer: 'signer'
};

export const IppAASAuthoritySettingsDataApiMapping = {
	FailedPasswordAttemptMaxCount: 'allowedFailedPasswordAttempts',
	FailedKBQAttemptMaxCount: 'allowedFailedKBQAttempts',
	InvitationExpiredHours: 'invitationExpiryHrsAfterSending',
	PasswordChangeRequiredDays: 'daysBeforePasswordChange',
	PasswordHistoryMaxCount: 'passwordsCountInPasswordHistory',
	TimeZone: 'timezone'
};

export const IppAASIndustrialPretreatmentSettingsDataMapping = {
	ReportElementTypeIdForIndustryFileUpload: 'attachmentType',
	ReportRepudiatedDays: 'maxDaysToRepudiateAfterReportEndDate',
	ResultQualifierValidValues: 'resultQualifier',
	FlowUnitValidValues: 'sampleFlowUnits',
	SampleNameCreationRule: 'createSampleNameUsing',
	ComplianceDeterminationDate: 'complianceDeterminationDate',
	MassLoadingConversionFactorPounds: 'massLoadingConversionFactor',
	MassLoadingResultToUseLessThanSign: 'massLoadingResults',
	MassLoadingCalculationDecimalPlaces: 'decimalPlacesForLoadingCalculations',
	AuthorityUserLicenseTotalCount: 'availableAuthorityLicenses',
	AuthorityLicensesInUse: 'authorityLicensesInUse',
	IndustryLicenseTotalCount: 'availableIndustryLicenses',
	IndustryLicensesInUse: 'industryLicensesInUse',
	UserPerIndustryMaxCount: 'industryUsersCountPerIndustry',
	EmailContactInfoName: 'contactNameOnEmails',
	EmailContactInfoPhone: 'contactPhoneOnEmails',
	EmailContactInfoEmailAddress: 'contactEmailAddressOnEmails'
};

export const IppPendingRegistrationsUserDataMapping = {
	Id: 'id',
	RegisteredOrgName: 'registeredOrgName',
	Organization: 'organization',
	Type: 'type',
	UserName: 'userName',
	FirstName: 'firstName',
	LastName: 'lastName',
	BusinessName: 'businessName',
	PhoneNumber: 'phone',
	Email: 'email',
	DateRegistered: 'dateRegistered',
	Role: 'role',
	Title: 'title',
	Phone: 'phone',
	Ext: 'ext',
	Address1: 'address1',
	Address2: 'address2',
	City: 'city',
	State: 'state',
	ZipCode: 'zipCode'
};

export enum SampleStatus {
	Draft = 'Draft',
	ReadyToReport = 'ReadyToReport',
	Reported = 'Reported'
}

export enum ReportPackageStatus {
	Scheduled = 'Scheduled',
	Draft = 'Draft',
	ReadyToSubmit = 'ReadyToSubmit',
	Submitted = 'Submitted',
	Accepted = 'Accepted',
	Repudiated = 'Repudiated',
	Rejected = 'Rejected',
	PendingAcceptance = 'PendingAcceptance',
	All = 'All',
	SubmittedPendingReview = 'SubmittedPendingReview',
	PendingReview = 'PendingReview',
	RepudiatedPendingReview = 'RepudiatedPendingReview',
	Error = 'Error'
}

export enum ReportToSampleStatus {
	Edit = 'edit',
	CopyAndEdit = 'copyAndEdit',
	AddSampleToReport = 'addSampleToReport'
}

export enum SignAndSubmitValidation {
	InvalidPassword = 'InvalidPassword',
	IncorrectKbqAnswer = 'IncorrectKbqAnswer',
	UserLockedPassword = 'UserLocked_Password',
	UserLockedKBQ = 'UserLocked_KBQ'
}

export enum SampleCompliance {
	Good = 'good',
	Bad = 'bad',
	None = 'none'
}

export const IppConstants = {
	fieldCharLimit: {
		email: 256,
		answer: 50,
		shortElementName: 50,
		longElementName: 100,
		parameterName: 254,
		certificationText: 2000,
		commentsAndDescription: 500,
		user: {
			title: 250,
			organization: 254,
			userName: 256,
			longInfo: 100,
			shortInfo: 50
		}
	},
	queryParams: {
		initialPage: '1',
		shortPageSize: '5'
	},
	shortWaitTime: 1200,
	textAreaMaxLength: 500,
	inputMaxLength: 100,
	textAreaRows: 4,
	newFormText: 'new',
	dateFormats: {
		yearMonthDay: 'YYYY-MM-DD',
		monthDayYear: 'MM/DD/YYYY',
		timeSecondsTwelveHourFormat: 'hh:mm:ss a'
	},
	translations: {
		sortDropDownQueryParam: 'sort=name asc',
		sortTranslationsQueryParam: '&sort=importFileTerm asc'
	},
	initialIndustryPathName: 'ipp/industry',
	initialAuthorityPathName: 'ipp/authority',
	authorityReportPackageDetailPath: 'reportPackages',
	industryReportPackageDetailPath: 'reportPackage',
	submittedPendingReviewIndex: 0,
	repudiatedReviewIndex: 1,
	corruptedCORReviewIndex: 2
};

export const IppTestConstants = {
	zero: 0,
	firstIndex: 1,
	pendingRegistrationsListArray: [
		localizationFile.ipp.pendingRegistrationUser.fields.firstName.label,
		localizationFile.ipp.pendingRegistrationUser.fields.lastName.label,
		localizationFile.ipp.pendingRegistrationUser.fields.email.label,
		localizationFile.ipp.pendingRegistrationUser.fields.registeredFor.label,
		localizationFile.ipp.pendingRegistrationUser.fields.registrationDate.label
	],
	firstNameLabel: localizationFile.ipp.pendingRegistrationUser.fields.firstName.label,
	registeredForLabel: localizationFile.ipp.pendingRegistrationUser.fields.registeredFor.label,
	registeredDateLabel: localizationFile.ipp.pendingRegistrationUser.fields.registrationDate.label,
	lastNameLabel: localizationFile.ipp.pendingRegistrationUser.fields.lastName.label,
	emailLabel: localizationFile.ipp.pendingRegistrationUser.fields.email.label,
	orgTypeLabel: localizationFile.ipp.pendingRegistrationUser.fields.orgName.label,
	dropDownValue: localizationFile.ipp.authorityAccount.roles.standard,
	roleFieldName: localizationFile.ipp.pendingRegistrationUser.fields.role.label,
	updatedText: 'Updated',
	dataProvidersText: localizationFile.ipp.industryAccount.dataProviders.pageHeader,
	dataProviderNameText: 'DP-',
	columnName: localizationFile.ipp.industryAccount.dataProviders.columns.name,
	dataProviderArray: [
		localizationFile.ipp.industryAccount.dataProviders.columns.name,
		localizationFile.ipp.industryAccount.dataProviders.columns.description,
		localizationFile.ipp.industryAccount.dataProviders.columns.lastModificationDateTimeLocal,
		localizationFile.ipp.industryAccount.dataProviders.columns.lastModifierFullName
	],
	badRequestStatusCode: 400,
	badRequestMessage: 'Bad Request',
	forbiddenStatusCode: 403,
	forbiddenMessage: 'Forbidden',
	unauthorizedException: 'UnauthorizedAccessException',
	onlyInternalUserCanAccess: 'Only internal users can access the admin portal',
	descriptionText: 'Description',
	dataProviderUpdatedName: 'Updated DataProvider',
	dataProviderUpdatedDescription: 'Updated Description',
	columnHeader: 'Column Header',
	required: 'Required***',
	dataFormat: 'Data Format',
	fieldSize: 'Field Size',
	fieldDescription: 'Field Description',
	exampleData: 'Example Data',
	additionalComments: 'Additional Comments',
	dataDescription: 'Data Descriptions',
	dataSourceId: 'dataSoucreId',
	updatedMonitoringPointText: 'Updated MP-',
	createdMonitoringPointText: 'Created MP-',
	updatedCtsEventTypeText: 'Updated ET-',
	createdCtsEventTypeText: 'Created ET-',
	updatedCollectionMethodText: 'Updated CM-',
	createdCollectionMethodText: 'Created CM-',
	updatedParameterText: 'Updated Parameter-',
	createdParameterText: 'Created Parameter-',
	updatedUnitText: 'Updated Unit-',
	createdUnitText: 'Created Unit-',
	unauthorizedStatusCode: 401,
	unauthorizedMessage: 'Unauthorized',
	standardRole: localizationFile.ipp.authorityAccount.roles.standard,
	adminRole: localizationFile.ipp.authorityAccount.roles.administrator,
	permissionMsg:
		'You do not have the required permissions to perform this action. Please contact your system administrator to change your permissions.',
	internalServerErrorStatusCode: 500,
	internalServerErrorMessage: 'Internal Server Error',
	manualAction: 'ManualAction',
	firstPage: '1',
	industryId: 'ippIndustryId',
	industryName: 'industryName',
	industryNumber: 'industryNumber',
	authorityToIndustryInvitation: 'AuthorityToIndustry',
	ippUserId: 'ippUserId',
	notFoundStatusCode: 404,
	notFoundMessage: 'Not Found',
	collectionMethodDrpDownValue: 'Trip blank',
	sampleTypeDrpDwnValue: 'SampAvg',
	qualifierValue: '>',
	flowUnitValue: 'mgd',
	parameterValue: 'Zinc, total',
	testText: 'test',
	enterKeyBoardBtn: 'enter',
	firstFileName: 'sheet1.xls',
	secondFileName: 'sheet2.xlsx',
	Accepted: 'Accepted',
	Draft: 'Draft',
	Scheduled: 'Scheduled',
	reportHasError: 'Report has errors',
	ippIndustrySelect: 'IPP Industry 001',
	integerValue: -1,
	draftReportPackagesHeaders: [
		localizationFile.ipp.reportPackage.package.columns.name,
		localizationFile.ipp.reportPackage.package.columns.periodStartDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.periodEndDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.lastModificationDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.lastModifierFullName
	],
	readyToSubmitReportPackagesHeaders: [
		localizationFile.ipp.reportPackage.package.columns.name,
		localizationFile.ipp.reportPackage.package.columns.periodStartDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.periodEndDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.lastModificationDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.lastModifierFullName
	],
	submittedReportPackagesHeaders: [
		localizationFile.ipp.reportPackage.package.columns.name,
		localizationFile.ipp.reportPackage.package.columns.periodStartDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.periodEndDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.submissionDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.submitterFirstName
	],
	rejectedReportPackagesHeaders: [
		localizationFile.ipp.reportPackage.package.columns.name,
		localizationFile.ipp.reportPackage.package.columns.periodStartDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.periodEndDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.dueDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.rejectionDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.submissionDateTimeLocal
	],
	repudiatedReportPackagesHeaders: [
		localizationFile.ipp.reportPackage.package.columns.name,
		localizationFile.ipp.reportPackage.package.columns.periodStartDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.periodEndDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.submissionDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.submitterFirstName,
		localizationFile.ipp.reportPackage.package.columns.repudiatorFirstName,
		localizationFile.ipp.reportPackage.package.columns.repudiationDateTimeLocal
	],
	pendingAcceptanceReportPackagesHeaders: [
		localizationFile.ipp.reportPackage.package.columns.name,
		localizationFile.ipp.reportPackage.package.columns.periodStartDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.periodEndDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.lastModificationDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.lastModifierFullName
	],
	viewLinkText: localizationFile.ipp.reportPackage.package.scheduledPackage.statusActions.view,
	createDraftLinkText: localizationFile.ipp.reportPackage.package.scheduledPackage.statusActions.createDraft,
	draftReportStatus: localizationFile.ipp.sideNav.draft,
	readyToSubmitReportStatus: localizationFile.ipp.sideNav.readyToSubmit,
	reportReadyToSubmitStatus: localizationFile.ipp.sideNav.readyToSubmitStatus,
	errorReportStatus: localizationFile.ipp.reportPackage.package.reportPackageErrorStatus,
	submittedReportStatus: localizationFile.ipp.sideNav.submitted,
	submittedStatus: localizationFile.ipp.sideNav.submittedReport,
	pendingAcceptanceReportStatus: localizationFile.ipp.sideNav.pendingAcceptance,
	acceptReportEventType: 'Report Approved',
	rejectReportEventType: 'Report Rejected',
	rejectedReportStatus: 'Submitted',
	readyToSubmit: 'Ready To Submit',
	normalWaitTime: 10000,
	highWaitTime: 100000,
	noRecordsMessage: 'No records available',
	grabCollectionMethod: 'GRAB',
	reportPackageDetails: localizationFile.ipp.reportPackage.package.reportPackageDetails,
	startAndEndDateAlertMsg: localizationFile.ipp.samples.step1.errorDatesRequiredMessage,
	startDateAlertMsg: localizationFile.ipp.samples.step1.errorStartDateRequiredMessage,
	endDateAlertMsg: localizationFile.ipp.samples.step1.errorEndDateRequiredMessage,
	monitoringPointAlertMsg: localizationFile.ipp.samples.step1.errorMonitoringPointRequiredMessage,
	collectionMethodAlertMsg: localizationFile.ipp.samples.step2.errorCollectionMethodRequiredMessage,
	sampleTypeAlertMsg: localizationFile.ipp.samples.step2.errorSampleTypeRequiredMessage,
	grabSampleDateWarning: localizationFile.ipp.samples.step2.grabSampleDateWarning,
	selectCollectionMethod: localizationFile.ipp.samples.step2.selectCollectionMethod,
	sampleTypeColName: localizationFile.ipp.samples.columns.ctsEventTypeName,
	attachmentTypeField: localizationFile.ipp.attachments.columns.reportElementTypeName,
	fileErrorMsg: localizationFile.ipp.attachments.errors.filesRequired,
	readyToReportHeadersArray: [
		localizationFile.ipp.samples.columns.monitoringPointName,
		localizationFile.ipp.samples.columns.ctsEventTypeName,
		localizationFile.ipp.samples.columns.collectionMethodName,
		localizationFile.ipp.samples.columns.startDateTimeLocal,
		localizationFile.ipp.samples.columns.endDateTimeLocal,
		localizationFile.ipp.samples.columns.lastModificationDateTimeLocal,
		localizationFile.ipp.samples.columns.lastModifierFullName
	],
	sampleStep1ReactEndpoint: 'sample/new/step1',
	samplesDraftHeadersArray: [
		localizationFile.ipp.samples.columns.monitoringPointName,
		localizationFile.ipp.samples.columns.ctsEventTypeName,
		localizationFile.ipp.samples.columns.collectionMethodName,
		localizationFile.ipp.samples.columns.startDateTimeLocal,
		localizationFile.ipp.samples.columns.endDateTimeLocal,
		localizationFile.ipp.samples.columns.lastModificationDateTimeLocal,
		localizationFile.ipp.samples.columns.lastModifierFullName
	],
	sampleIdHeaderName: 'Sample ID',
	labSampleIdHeaderName: localizationFile.ipp.samples.columns.labSampleIdentifier,
	invitationIdKey: 'invitationId',
	ippUserIdKey: 'ippUserId',
	deletionSuccessStatusCode: 204,
	readyToReport: localizationFile.ipp.samples.columns.isReadyToReport,
	noRecordsAvailable: 'No records available',
	dataProviderValue: 'Test Lab 001',
	importFileExtErrMsg: localizationFile.ipp.samples.errors.importSampleInvalidExtension,
	importFileFormatErrMsg: localizationFile.ipp.samples.errors.fileImportFailed,
	monitoringPointValue: '146-Retired',
	parameterName: 'Copper, total',
	copperParameter: 'Copper',
	missingFieldName: 'MonitoringPoint',
	reportPackageSubmissionComment: 'Report Package is reviewed',
	reportedSampleDetailPageName: localizationFile.ipp.samples.sampleDetails,
	repudiatedReportStatus: localizationFile.ipp.reportPackage.package.columns.repudiationDateTimeLocal,
	submitterFirstNameColName: localizationFile.ipp.reportPackage.package.columns.submitterFirstName,
	repudiatorFirstNameColName: localizationFile.ipp.reportPackage.package.columns.repudiatorFirstName,
	industryColName: localizationFile.ipp.reportPackage.package.columns.organizationName,
	submittedReportPackageFilterName: localizationFile.screen.filterModal.lookIn.ipp.submittedReportPackages,
	acceptedReportPackageFilterName: localizationFile.screen.filterModal.lookIn.ipp.acceptedReportPackages,
	repudiatedReportPackageFilterName: localizationFile.screen.filterModal.lookIn.ipp.repudiatedReportPackages,
	allReportPackageFilterName: localizationFile.screen.filterModal.lookIn.ipp.allReportPackages,
	industriesFilterName: localizationFile.ipp.industries.industryColumns.title,
	isOperator: localizationFile.screen.filterModal.is,
	successStatusCode: 200,
	noContentsSuccessStatusCode: 204,
	originalFileNameField: localizationFile.ipp.attachments.columns.originalFileName,
	auditLogsColumns: [
		localizationFile.ipp.auditLog.eventCategory,
		localizationFile.ipp.auditLog.eventType,
		localizationFile.ipp.auditLog.userEmailAddress,
		localizationFile.ipp.auditLog.creationDateTimeLocal
	],
	usersColumns: [
		localizationFile.ipp.authorityAccount.userListColumns.firstName,
		localizationFile.ipp.authorityAccount.userListColumns.lastName,
		localizationFile.ipp.authorityAccount.userListColumns.phoneNumber,
		localizationFile.ipp.authorityAccount.userListColumns.email,
		localizationFile.ipp.authorityAccount.userListColumns.registrationDateTimeUtc,
		localizationFile.ipp.authorityAccount.userListColumns.isEnabled
	],
	pendingInvitationsColumns: [
		localizationFile.ipp.authorityAccount.pendingInvitationsColumns.firstName,
		localizationFile.ipp.authorityAccount.pendingInvitationsColumns.lastName,
		localizationFile.ipp.authorityAccount.pendingInvitationsColumns.emailAddress
	],
	templateColumnName: localizationFile.ipp.reportPackage.templates.name,
	organizationColumnName: localizationFile.ipp.pendingRegistrationUser.fields.orgName.label,
	industryNameColumnName: localizationFile.ipp.industries.industryColumns.industryName,
	industriesColumns: [
		localizationFile.ipp.industries.industryColumns.industryNumber,
		localizationFile.ipp.industries.industryColumns.industryName,
		localizationFile.ipp.industries.industryColumns.addressLine1,
		localizationFile.ipp.industries.industryColumns.classification,
		localizationFile.ipp.industries.industryColumns.isEnabled,
		localizationFile.ipp.industries.industryColumns.hasSignatory,
		localizationFile.ipp.industries.industryColumns.assignedTo
	],
	pendingRegistrationColumns: [
		localizationFile.ipp.pendingRegistrationsList.tableColumns.firstName,
		localizationFile.ipp.pendingRegistrationsList.tableColumns.lastName,
		localizationFile.ipp.pendingRegistrationsList.tableColumns.email,
		localizationFile.ipp.pendingRegistrationsList.tableColumns.organizationType,
		localizationFile.ipp.pendingRegistrationsList.tableColumns.registeredFor,
		localizationFile.ipp.pendingRegistrationsList.tableColumns.registrationDateTimeUtc
	],
	roleDropdownValidValues: [
		'',
		localizationFile.ipp.authorityAccount.roles.standard,
		localizationFile.ipp.authorityAccount.roles.administrator
	],
	templatesColumns: [
		localizationFile.ipp.reportPackage.templates.name,
		localizationFile.ipp.reportPackage.templates.description,
		localizationFile.ipp.reportPackage.templates.effectiveDateTimeLocal,
		localizationFile.ipp.reportPackage.templates.lastModificationDateTimeLocal,
		localizationFile.ipp.reportPackage.templates.lastModifierFullName,
		localizationFile.ipp.reportPackage.templates.activeStatus
	],
	validTemplateSectionNames: [
		'Report Details',
		localizationFile.ipp.reportPackage.reportTemplateElement.samplesAndResults,
		localizationFile.ipp.reportPackage.reportTemplateElement.attachments,
		localizationFile.ipp.reportPackage.reportTemplateElement.certifications,
		'Assign Industries'
	],
	parameterGroupsColumns: [
		localizationFile.ipp.reportPackage.parameterGroup.columns.name,
		localizationFile.ipp.reportPackage.parameterGroup.columns.description,
		localizationFile.ipp.reportPackage.parameterGroup.columns.lastModificationDateTimeLocal,
		localizationFile.ipp.reportPackage.parameterGroup.columns.lastModifierFullName,
		localizationFile.ipp.reportPackage.parameterGroup.columns.isActive
	],
	availableParametersColumns: ['Name', 'Add'],
	selectedParametersColumns: ['Name', 'Remove'],
	certificationColumns: [
		localizationFile.ipp.reportPackage.parameterGroup.columns.name,
		localizationFile.ipp.reportPackage.parameterGroup.columns.description,
		localizationFile.ipp.reportPackage.parameterGroup.columns.lastModificationDateTimeLocal,
		localizationFile.ipp.reportPackage.parameterGroup.columns.lastModifierFullName
	],
	attachmentColumns: [
		localizationFile.ipp.reportPackage.parameterGroup.columns.name,
		localizationFile.ipp.reportPackage.parameterGroup.columns.description,
		localizationFile.ipp.reportPackage.parameterGroup.columns.lastModificationDateTimeLocal,
		localizationFile.ipp.reportPackage.parameterGroup.columns.lastModifierFullName
	],
	pendingReviewsColumns: [
		localizationFile.ipp.reportPackage.package.columns.organizationReferenceNumber,
		localizationFile.ipp.reportPackage.package.columns.organizationName,
		localizationFile.ipp.reportPackage.package.columns.name,
		localizationFile.ipp.reportPackage.package.columns.periodStartDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.periodEndDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.submissionDateTimeLocal
	],
	repudiatedColumns: [
		localizationFile.ipp.reportPackage.package.columns.organizationReferenceNumber,
		localizationFile.ipp.reportPackage.package.columns.organizationName,
		localizationFile.ipp.reportPackage.package.columns.name,
		localizationFile.ipp.reportPackage.package.columns.periodStartDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.periodEndDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.submissionDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.repudiationDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.lastSentDateTimeLocal
	],
	allReviewsColumns: [
		localizationFile.ipp.reportPackage.package.columns.organizationReferenceNumber,
		localizationFile.ipp.reportPackage.package.columns.organizationName,
		localizationFile.ipp.reportPackage.package.columns.name,
		localizationFile.ipp.reportPackage.package.columns.periodStartDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.periodEndDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.submissionDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.repudiationDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.lastSentDateTimeLocal
	],
	errorReviewsColumns: [
		localizationFile.ipp.reportPackage.package.columns.organizationReferenceNumber,
		localizationFile.ipp.reportPackage.package.columns.organizationName,
		localizationFile.ipp.reportPackage.package.columns.name,
		localizationFile.ipp.reportPackage.package.columns.periodStartDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.periodEndDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.submissionDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.repudiationDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.lastSentDateTimeLocal,
		localizationFile.ipp.reportPackage.package.columns.reportPackageId
	],
	unitTranslationColumns: [
		localizationFile.ipp.unitTranslations.tableColumns.name,
		localizationFile.ipp.unitTranslations.tableColumns.systemUnitName,
		localizationFile.ipp.unitTranslations.tableColumns.isAvailableToRegulatee,
		localizationFile.ipp.unitTranslations.tableColumns.showInBadgeCount,
		localizationFile.ipp.unitTranslations.tableColumns.action
	],
	sampleImportTemplatesColumns: [
		localizationFile.ipp.sampleImportTemplateList.tableColumns.columnHeader,
		localizationFile.ipp.sampleImportTemplateList.tableColumns.columnDescription,
		localizationFile.ipp.sampleImportTemplateList.tableColumns.dataFormat,
		localizationFile.ipp.sampleImportTemplateList.tableColumns.required,
		localizationFile.ipp.sampleImportTemplateList.tableColumns.action
	],
	industryAttachmentColumns: [
		localizationFile.ipp.attachments.columns.name,
		localizationFile.ipp.attachments.columns.originalFileName,
		localizationFile.ipp.attachments.columns.description,
		localizationFile.ipp.attachments.columns.reportElementTypeName,
		localizationFile.ipp.attachments.columns.uploadDateTimeUtc,
		localizationFile.ipp.attachments.columns.uploaderUserFullName,
		localizationFile.ipp.attachments.columns.attachmentStatus
	],
	translationColumns: [
		localizationFile.ipp.industryAccount.dataProviders.translations.columns.importFileTerm,
		localizationFile.ipp.industryAccount.dataProviders.translations.columns.linkoExchangeTerm
	],
	dataTranslationColumns: [
		localizationFile.ipp.industryAccount.dataProviders.translations.columns.importFileTerm,
		localizationFile.ipp.industryAccount.dataProviders.translations.columns.linkoExchangeTerm
	],
	duplicateReasonErrMsg: 'A(n) Reason with the same name already exists. Change the name and try again.'
};

export const FogTestConstants = {
	signature:
		'data:image/png;base64,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',
	zeroIndex: 0,
	badRequestStatusCode: 400,
	badRequestMessage: 'Bad Request',
	deletionSuccessStatusCode: 204,
	forbiddenStatusCode: 403,
	forbiddenMessage: 'Forbidden',
	integerValue: -1,
	internalServerErrorStatusCode: 500,
	internalServerErrorMessage: 'Internal Server Error',
	notFoundStatusCode: 404,
	notFoundMessage: 'Not Found',
	eventType: 'QA-EventType',
	eventTypeGeneric: 'code=Generic',
	eventCategoryGeneric: 'eventCategory=Generic'
};

export const UserTypes = {
	admin: localizationFile.ipp.authorityAccount.roles.administrator,
	standard: localizationFile.ipp.authorityAccount.roles.standard
};

export const IppSamples = {
	sampleStep1ReactEndpoint: 'sample/new/step1'
};

export const NotificationTypes = {
	success: 'success',
	error: 'error'
};

export const IppHelpUrls = {
	authority: '/ipp/authority/',
	industry: '/ipp/industry/',
	lab: '/ipp/lab/',
	reportManual: '/ipp/reportEventManual/'
};

export const FogHelpUrls = {
	authority: '/fog/authority',
	hauler: '/fog/hauler',
	facility: '/fog/facility'
};

export const SeattleAuthorityConstants = {
	authorityName: 'Seattle Public Utilities',
	certificationStatementPart1:
		'"I certify to the best of my knowledge that the above statements are true and correct." Knowingly providing false or inaccurate information will be considered a "willful or knowing" violation under Seattle Municipal Code (SMC) 21.15.3562(B)(1)(c)(iii) and may result in additional penalties as outlined in this section.',
	certificationStatementPart2:
		'Personal information entered on this form is subject to Washington Public Records Act, and may be subject to disclosure to a third-party requestor. At the City of Seattle, we are committed to protecting your privacy and will ensure that any disclosures are done according to law. To learn more about how this information is managed please see our ',
	privacyStatement: 'Privacy Statement',
	fogWasteTypeLabel: 'FOG',
	gallonsUnit: 'gal',
	inchesUnit: 'in',
	privacyStatementWebsite: 'http://www.seattle.gov/tech/initiatives/privacy'
};

//You can define differet config at file <.env.development> for your local dev envionment
export const oidcEnvConfig = {
	oidcAuthUrl: process.env.REACT_APP_OIDC_AUTH_URL || 'https://api-feature-us.aquaticinformatics.net',
	oidcClientId: process.env.REACT_APP_OIDC_CLIENT_ID || 'ACP.AuthCode',
	oidClientSecret: process.env.REACT_APP_OIDC_CLIENT_SECRET || '0CA470E3-6CC4-4CC8-B6DD-F956F94EB5EE',
	oidcPublicUrl: process.env.REACT_APP_OIDC_PUBLIC_URL || 'https://api-feature-us.aquaticinformatics.net',
	aqiAppHomeUrl:
		process.env.REACT_APP_AQI_APP_HOME_URL || 'https://feature-us.aquaticinformatics.net/app-home/landing'
};

export const oidcMetadata = {
	issuer: oidcEnvConfig.oidcAuthUrl,
	jwks_uri: oidcEnvConfig.oidcAuthUrl + '/.well-known/openid-configuration/jwks',
	authorization_endpoint: oidcEnvConfig.oidcAuthUrl + '/connect/authorize',
	token_endpoint: oidcEnvConfig.oidcAuthUrl + '/connect/token',
	userinfo_endpoint: oidcEnvConfig.oidcAuthUrl + '/connect/userinfo',
	end_session_endpoint: oidcEnvConfig.oidcAuthUrl + '/connect/endsession',
	check_session_iframe: oidcEnvConfig.oidcAuthUrl + '/connect/checksession',
	revocation_endpoint: oidcEnvConfig.oidcAuthUrl + '/connect/revocation',
	introspection_endpoint: oidcEnvConfig.oidcAuthUrl + '/connect/introspect'
};

export const gmailMessages = {
	inviteSubject: 'Invitation to',
	inviteBody: "You've been invited to be a user of Aquatic Compliance Platform",
	forgotSubject: 'Aquatic Compliance Platform Forgot Password',
	forgotBody: 'To set a new password'
};

export const doNotTranslateTags = {
	start: '[[Do not translate start]]',
	end: '[[Do not translate end]]'
};
export const EmitterEvents = {
	NewPasswordLoaded: 'NewPasswordPageLoaded',
	OpenSignaturePadEvent: 'OpenSignaturePad'
};
